import './assets/css/common.css'
import './utils/directive'
import '../src/font/font.css' // 全局引入css文件

import Vue from 'vue'
import App from './App.vue'
import store from "./store";
import router from './router'
import dayjs from 'dayjs'
import apis from './apis'
import bus from './utils/eventBus'
import wxShare from './utils/wxShare'
import myUtils from './utils/myUtils'
import filters from './utils/filters'
import { Dialog } from 'vant';
import storage from "@/utils/storage";
 


import {
  Lazyload, Toast, ImagePreview, List, Empty, Swipe, Rate,
  Loading, RadioGroup, Step, Steps, Uploader, DatetimePicker,
  Popup, Picker, DropdownMenu, Area, DropdownItem, Radio, Checkbox, 
  SwipeItem, NoticeBar, Tab, Tabs, Tabbar, TabbarItem, NavBar, Form,
  Field, Button, Search, Tag, Icon, CellGroup, Cell, PullRefresh,
  Divider, Badge, Overlay,Grid, GridItem,Switch,Collapse, CollapseItem,Calendar,
  ActionSheet,TreeSelect,Col, Row, CheckboxGroup  
} from 'vant'
import { Image as VanImage } from 'vant';
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.prototype.bus = bus
Vue.prototype.apis = apis
Vue.prototype.Toast = Toast
Vue.prototype.wxShare = wxShare
Vue.prototype.myUtils = myUtils
Vue.prototype.dayjs = dayjs
Vue.prototype.Dialog = Dialog
//全局注册 filter
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.prototype.getUser = function () {
  let enterInfo = JSON.parse(localStorage.getItem('enterInfo'))
  if (!storage.token) {
    //判断是否登录 未登录false
    return false
  } else {
    //如果登录了 没有用户信息是游客就需要去企业认证
    if ((!enterInfo || !enterInfo.id) || !enterInfo.name) {
      return false
    }
    return true
  }
}

// 使用 Vue.use 和 Vue.component 全局注册组件，这里的第一个参数就是后面可以在其他组件内使用的标签名，并使用动态导入来延迟加载组件
// Vue.component('TitleBar', () => import('./components/TitleBar'))
Vue.component('TitleBarBack', () => import('./components/TitleBarBack'))
Vue.component('baseDialog', () => import('./components/BaseDialog'))
Vue.component('infiniteList', () => import('./components/InfiniteList'))
Vue.component('dropdownMenu', () => import('./components/DropdownMenu'))
Vue.component('depDdropdownMenu', () => import('./components/DeptDropdownMenu'))

Vue.use(List)
  .use(Toast)
  .use(Area)
  .use(Swipe)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Loading)
  .use(VanImage)
  .use(SwipeItem)
  .use(Tab)
  .use(Tabs)
  .use(Tabbar)
  .use(NavBar)
  .use(TabbarItem)
  .use(Rate)
  .use(Form)
  .use(Field)
  .use(Button)
  .use(Search)
  .use(Tag)
  .use(Icon)
  .use(Cell)
  .use(CellGroup)
  .use(PullRefresh)
  .use(RadioGroup)
  .use(Radio)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Picker)
  .use(Popup)
  .use(NoticeBar)
  .use(Step)
  .use(Steps)
  .use(Uploader)
  .use(DatetimePicker)
  .use(Empty)
  .use(Dialog)
  .use(ImagePreview)
  .use(Divider)
  .use(Badge)
  .use(Overlay)
  .use(Grid)
  .use(GridItem)
  .use(Checkbox)
  .use(Switch)
  .use(Collapse)
  .use(CollapseItem)
  .use(Calendar)
  .use(ActionSheet)
  .use(TreeSelect )
  .use(Col)
  .use(Row)
  .use(Lazyload, {
    // error: require('./assets/img/img_placeholder.svg'),
    // loading: require('./assets/img/img_placeholder.svg'),
  })
// 开发环境下面使用vConsole进行调试  
// if (process.env.NODE_ENV !== 'production') {
//   const VConsole = require('vconsole')
//   new VConsole()
// }
Vue.mixin({
  data: () => ({
    thirdParty: {
      /** 事项待办 */
      todo: 'https://www.cqjxf.com:40084/gzh_h5/#/backlogList',
      /** 园区通知 */
      parkNotice: 'https://www.cqjxf.com:40084/gzh_h5/#/parkNotice',
      /** 诉求直达 */
      directAppeal: 'https://www.cqjxf.com:40084/gzh_h5/#/appeal',
      /** 我的述求 */
      myAppeal: 'https://www.cqjxf.com:40084/gzh_h5/#/feedback',
      /* 安环巡检 */
      inspection: 'https://www.cqjxf.com:10002/h5'
    }
  }),
  methods: {
    otherJump(url) {
      if (url) {
        window.location.href = url + '?apiToken=' + localStorage.getItem('token')
      }
    },
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
